<template>
  <div
    class="document-grid-card w-full m-2"
    :class="{ checked: selected, 'cursor-pointer': isFolder, 'document-grid-card__folder': isFolder }"
    v-on:mouseover="mouseOver"
    v-on:mouseleave="mouseLeave"
    @click="toggleCard"
  >
    <div class="card-top-area">
      <div class="hover-area relative">
        <div
          v-show="isHovered || selected"
          class="absolute top-0 left-0 right-0"
        >
          <div class="float-left" @click.stop="">
            <vs-checkbox
              v-model="selected"
              :color="AISEA_COLOR.BLUE"
              class="action-button-icon"
            ></vs-checkbox>
          </div>
          <div class="float-right" @click.stop="">
            <!-- <feather-icon
              v-if="isPreview"
              class="action-button-icon icon-bg-white cursor-pointer"
              svgClasses="h-6 w-6"
              @click.stop="togglePreview()"
              icon="EyeIcon"
            ></feather-icon> -->
            <div v-if="!isDisabledDropdown">
              <content-dropdown
                :document="document"
                :isFolder="isFolder"
              ></content-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="flex h-full items-center justify-center">
        <div class="action-button-icon icon-bg-white">
          <document-thumbnail-view
            class="action-button-icon icon-bg-white"
            :document="document"
            :isFolder="isFolder"
            :height="thumbnailHeight"
          ></document-thumbnail-view>
        </div>
      </div>
    </div>

    <div class="catd-bottom-area px-2 py-2">
      <div class="text-area flex items-center ... text-sm">
        <div class="document-name-text overflow-hidden">
          <vx-tooltip
            :text="document.name"
            class="document-name-tooltip min-w-0 truncate ..."
          >
            <span>{{ document.name }}</span>
          </vx-tooltip>
        </div>
        <div>
          <awe-icon
            v-if="isStarIcon"
            name="star"
            scale="0.8"
            class="important-icon ml-1"
          />
        </div>
      </div>
      <div class="flex justify-between text-xs">
        <div class="upload-time-text flex">
          <span v-if="!this.isFolder" class="flex">
            <feather-icon
              svgClasses="h-3 w-3"
              class="mr-1"
              icon="EyeIcon"
            ></feather-icon>
            {{ lastUpdateTime }}
          </span>
        </div>
        <div class="text-right flex">
          <span class="document-size-text truncate">{{ fileSize }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DOCUMENT_KIND } from "@/config/const";
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import ContentDropdown from "./DocumentContentDropdown"
import { UnitUtil } from "@/utils";
import moment from "moment";
import 'moment/locale/ja'
import DocumentThumbnailView from "./DocumentThumbnailView";

const {
  mapState: mapStateOfenterpriseDocumentManager,
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

moment.locale('ja');


export default {
  mixins: [ColorMixin, DocumentMixin],
  components: {
    ContentDropdown,
    DocumentThumbnailView,
  },
  props: {
    document: Object,
    isFolder: Boolean
  },
  data () {
    return {
      isHovered: false,
      thumbnailHeight: 80
    }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager(["documentRootPath", "selectedDocuments"]),
    selected: {
      get () {
        return this.document.selected
      },
      set (data) {
        const payload = {
          document: this.document,
          selected: data
        }
        this.SET_SELECTED_DOCUMENTS(payload);
      }
    },
    kind () {
      if (this.isFolder) return "folder"
      return this.getDocumentMimeKind(this.document.type)
    },
    isPreview () {
      return this.kind === DOCUMENT_KIND.IMAGE || this.kind === DOCUMENT_KIND.PDF;
    },
    fileSize () {
      if (!this.document.size) return "";
      return UnitUtil.formatBytes(this.document.size, 0);
    },
    fileUpdated () {
      if (this.isFolder) return ""
      return moment(this.document.updated).format("YYYY-MM-DD kk:mm")
    },
    lastUpdateTime () {
      const updated = moment(this.document.updated)
      const diff = moment().to(updated)
      return diff
    },
    isStarIcon () {
      if (!this.document.important) return false;
      return !this.isFolder && this.document.important
    },
    isDisabledDropdown () {
      return this.selectedDocuments.length > 0;
    }
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager([
      "PUSH_CURRENT_PATH",
      "SET_SELECTED_DOCUMENTS",
      "RESET_DOCUMENT_SEARCH"
    ]),
    ...mapActionsOfenterpriseDocumentManager([
      "getFileUrl",
      "selectCard"
    ]),
    async toggleCard () {
      if (!this.isFolder) return
      this.$vs.loading();
      const pathItems = this.document.path.replace(this.documentRootPath, "").split("/").map(item => { return { name: item } })
      const payload = {
        pathItems: pathItems,
        path: this.document.path
      };
      await this.selectCard(payload);
      this.$vs.loading.close();
    },
    mouseOver () {
      this.isHovered = true
    },
    mouseLeave () {
      this.isHovered = false
    },
    async togglePreview () {
      this.$vs.loading();
      try {
        const url = await this.getFileUrl(this.document.path);
        window.open(url, "_blank");
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.notify({
          title: "画像情報の取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
        this.$vs.loading.close();
      }
    },
  },
  beforeDestroy () {
    //ツールチップが消えていない場合、消す。
    document.querySelectorAll('body > div.vs-tooltip').forEach(el => {
      if (document.body.contains(el)) {
        document.body.removeChild(el);
      }
    });
  },
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";
@import "src/assets/scss/aisea/document-manager";

.document-name-tooltip {
  word-break: break-all;
}

.document-grid-card {
  border: 1px solid $aisea-light-gray;
  border-radius: 5px;
  overflow: hidden;

  .card-top-area {
    background: $aisea-white;
    height: 80px;

    .hover-area {
      z-index: 100;

      .action-button-icon {
        border-radius: 4px;
        padding: 2px;
        margin: 6px;
        color: $aisea-gray;
      }
      .icon-bg-white {
        background: $aisea-white;
      }

      .thumbnail-area {
        height: 80px;
      }
    }
  }

  .catd-bottom-area {
    .text_area {
      word-break: break-all;
    }

    .document-name-text {
      font-weight: 500;
    }

    .document-size-text {
      color: $aisea-gray;
    }

    .upload-time-text {
      color: $aisea-gray;
    }

    .star-icon {
      color: $aisea-blue;
    }
  }
}

.checked {
  border: 1px solid $aisea-blue;
}
</style>